import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  type SxProps,
  type Theme,
} from "@mui/material";
import { type ReactNode } from "react";

export interface DialogProps {
  actions: ReactNode;
  contentSx?: SxProps<Theme>;
  dialogType: "custom" | "confirm" | "info";
  /** When true, focus is not trapped in the dialog. Use for content that portals outside the dialog (e.g. MUI X pickers). */
  disableEnforceFocus?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
  onDialogClose: () => void;
  open: boolean;
  paperSx?: SxProps<Theme>;
  title: ReactNode;
  titleSx?: SxProps<Theme>;
}

export const Dialog = (props: DialogProps) => {
  const {
    actions,
    contentSx,
    dialogType,
    disableEnforceFocus = false,
    maxWidth = "md",
    onDialogClose,
    open,
    paperSx,
    title,
    titleSx,
  } = props;

  return (
    <MuiDialog
      aria-labelledby="dialog-title"
      disableEnforceFocus={disableEnforceFocus}
      fullWidth
      maxWidth={maxWidth}
      onClose={onDialogClose}
      open={open}
      slotProps={{
        paper: {
          sx: paperSx,
        },
      }}
    >
      <DialogTitle id="dialog-title" sx={{ m: 0, p: 2, ...titleSx }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onDialogClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={contentSx}>
        {dialogType === "custom" && actions}
      </DialogContent>
      {dialogType !== "custom" && <DialogActions>{actions}</DialogActions>}
    </MuiDialog>
  );
};

export default Dialog;
